import { useI18n } from 'vue-i18n';

// Labels for the backend-declared flags and configuration fields. Falls back to the raw
// key so a flag added to ClientSettings::Features still renders before someone translates
// it, instead of showing an empty row.
export function useClientSettingsLabels() {
  const { t, te } = useI18n();

  const translateOrKey = (path, key) => (te(path) ? t(path) : key);

  return {
    featureLabel: key =>
      translateOrKey(`CLIENT_SETTINGS.FEATURES.${key.toUpperCase()}`, key),
    fieldLabel: key =>
      translateOrKey(`CLIENT_SETTINGS.CONFIG.${key.toUpperCase()}`, key),
    // A filled-in example for the json fields, shown as the textarea placeholder. Unlike
    // the labels this falls back to empty: a raw key inside the textarea would read as
    // content the admin has to delete.
    fieldExample: key => {
      const path = `CLIENT_SETTINGS.CONFIG_EXAMPLE.${key.toUpperCase()}`;
      return te(path) ? t(path) : '';
    },
  };
}
